import useGameState, {
  GameAction,
  useGameActionDispatch,
} from "app/game/useGameState";
import { GODOT_EVENT, useGodotListener } from "app/godot-embed/godot-bridge";
import { formatGameTime } from "app/util/timeUtils";
import { useEffect, useState } from "react";

interface GameTimerProps {
  pauseTimer: boolean;
}

export default function GameTimer(props: GameTimerProps) {
  const { gameTime } = useGameState();
  const dispatch = useGameActionDispatch();
  const [runTimer, setRunTimer] = useState(false);

  useEffect(() => {
    if (!runTimer || props.pauseTimer) {
      return;
    }

    const interval = setInterval(() => {
      dispatch({
        type: GameAction.GAME_TIME_INCREMENTED,
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [runTimer, props.pauseTimer, dispatch]);

  useGodotListener(GODOT_EVENT.GAMEPLAY_START, () => setRunTimer(true));

  return (
    <div className="text-lg">
      <p>{formatGameTime(gameTime)}</p>
    </div>
  );
}
